export const LOADING_STATUSES: {
  IDLE: TLoadingStatus;
  LOADING: TLoadingStatus;
  ERROR: TLoadingStatus;
} = {
  IDLE: 'idle',
  LOADING: 'loading',
  ERROR: 'error',
};

export const MARKER_WIDTH = 30; // px

export const BAD_POST_CODE_RESPONSE = 'INVALID_POSTCODE_FORMAT';
